export default "__VITE_ASSET__DmwG1ih$__"